import React, { FC } from 'react'
import { Fonts } from 'components/base-ui'
import CircleImage from 'components/base-ui/CircleImage'
import styled from 'styled-components'
import { HeadLineMedium } from 'components/base-ui/FontsV2'

interface Props {
  logoPath: string
  brandName: string
  locationName: string
  tableName: string
}

const Header: FC<Props> = ({ logoPath, brandName, locationName, tableName }) => {
  return (
    <Wrapper>
      <BrandWrapper>
        <CircleImage path={logoPath} size="30px" />
        <Fonts.H2>{brandName}</Fonts.H2>
      </BrandWrapper>
      <DetailsWrapper>
        <LocationDesc>
          <HeadLineMedium color="darkGrey">{locationName}</HeadLineMedium>
          <TableName>{tableName}</TableName>
        </LocationDesc>
      </DetailsWrapper>
    </Wrapper>
  )
}

export default Header

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.spacing.S};
  column-gap: 15px;
`

const BrandWrapper = styled.div`
  display: flex;
  column-gap: ${({ theme }) => theme.spacing.XS};
`

const DetailsWrapper = styled.div`
  display: flex;
`

const LocationDesc = styled.div`
  display: flex;
  flex-direction: column;
  column-gap: 5px;
  width: 75vw;
  color: ${({ theme }) => theme.colors.darkGrey};
`

const TableName = styled(Fonts.H3)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${({ theme }) => theme.colors.base};
`
